import { Card, Flex, Text } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import BadgeStatus from '../../components/elements/BadgeStatus';
import Button from '../../components/elements/Button';
import GridCell from '../../components/elements/GridCell';
import HistoryLog from '../../components/elements/HistoryLog';
import { IconHistoryFilled } from '../../components/icons/IconHistoryFilled';
import styles from './styles.scoped.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSearchNik } from './action';
import { useParams } from 'react-router-dom';
import LoadingBars from '../../components/elements/LoadingBars';
import Skeleton from '../../components/elements/Skeleton';
import { AppContext } from '../../contexts';
import EmptyState from '../../components/fragments/EmptyState/index.jsx';
import CustomerTypeList from '../../components/fragments/CustomerTypeList/index';

export default function Detail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { setBreadcrumbs } = useContext(AppContext);
  const [isShowDataPlain, setIsShowDataPlain] = useState(true);
  const { dataNikManagement } = useSelector((state) => state.nikManagement);
  const searchResult = dataNikManagement?.data || {};

  useEffect(() => {
    dispatch(fetchSearchNik(id, isShowDataPlain));
    setBreadcrumbs([
      { name: 'Blokir & Aktifkan NIK', to: '/customer-setting' },
      'Rincian Data Pelanggan'
    ]);
  }, [id, isShowDataPlain]);

  const handleShowDataPlain = () => {
    setIsShowDataPlain(!isShowDataPlain);
  };

  const mockHistory = [
    {
      'actionType': 'block',
      'reason': 'NIK terblokir oleh sistem',
      'reasonDetail': 'NIK pelanggan yang didaftarkan tidak valid.',
      'isRequestUnblock': false
    },
  ];

  const hasHistory = (searchResult.history?.length ?? 0) > 0;

  const renderHistoryContent = () => {
    if (searchResult.history?.length) {
      return <HistoryLog history={searchResult.history} />;
    }

    if (!hasHistory && searchResult.isBlocked) {
      return <HistoryLog history={mockHistory} permanentBlock={true} />;
    }

    return (
      <EmptyState title="Belum ada riwayat blokir dan aktivasi NIK pelanggan" />
    );
  };

  return (
    <div>
      <Card px={24} radius={'12px'} withBorder>
        <Card.Section className={styles.cardSection} p="md">
          <Flex direction={{ base: 'column', md: 'row' }} gap={10} justify={'space-between'} w={'100%'}>
            <Flex align={'center'} gap={10}>
              <Text size="lg" weight={600}>Data Pelanggan LPG 3 Kg</Text>
              <BadgeStatus label={searchResult.isBlocked ? 'NIK Diblokir' : 'Aktif'} />
            </Flex>
            <Button className={styles.btnIcon} disabled={dataNikManagement.isLoading} onClick={handleShowDataPlain} style={'blue'}>
              {dataNikManagement.isLoading && <LoadingBars size={1} />}
              <img
                alt={isShowDataPlain ? 'show' : 'hide'}
                height={10}
                src={`/assets/ic-password-${isShowDataPlain ? 'show' : 'hide'}-white.svg`}
                width={15}
              />
              {isShowDataPlain ? 'Tampilkan Data' : 'Sembunyikan Data'}
            </Button>
          </Flex>
        </Card.Section>
        {dataNikManagement.isLoading ? (
          <Card className={styles.loadingCard} p="md" radius={'12px'} withBorder>
            <Skeleton />
          </Card>
        ) : (
          <>
            <GridCell data={searchResult.name} label="Nama Pelanggan" left={3} />
            <GridCell data={searchResult.nationalityId} label="No. KTP Pemilik" left={3} />
            <GridCell data={searchResult.phoneNumber} label="No. Handphone Pelanggan" left={3} />
            <GridCell data={searchResult.email} label="Email Pelanggan" left={3} />
            <GridCell data={<CustomerTypeList customerTypes={searchResult?.customerTypes} />} label="Jenis Pelanggan" left={3} />
            <Card withBorder>
              <Card.Section className={styles.cardSection} p="md">
                <Flex align={'center'} gap={10}>
                  <IconHistoryFilled className={styles.iconHistoryFilled} />
                  <Text fw={600}>Riwayat Blokir dan Aktifkan NIK Pelanggan</Text>
                </Flex>
              </Card.Section>
              <Card.Section className={styles.cardHistory} p="md">
                {renderHistoryContent()}
              </Card.Section>
            </Card>
          </>
        )}
      </Card>
    </div>
  );
}
